import {toast} from "@/hooks/use-toast";


export const showError = (description: string, title?: string): void => {
    toast({
        title,
        description,
        variant: "destructive",
    })
}

export const showSuccess = (description: string, title?: string): void => {
    toast({
        title,
        description,
    })
}

export const showCommonApiError = (cause: string) => {
    toast({
        title: 'Uh oh! Something went wrong.',
        description: `An error occurred while ${cause}. Please try again later`,
        variant: "destructive"
    })
}